export enum LanguageTypes {
  EN = 'en',
  SR = 'sr',
  SR_CYR = 'sr_cyr',
}
